/**
* 应用管理
*/
<template>
  <div>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入应用名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">创建新应用</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table ref="table" size="small" :data="listData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
              highlight-current-row
              v-loading="loading" border
              element-loading-text="拼命加载中"

              :row-key="getRowKeys"
              :expand-row-keys="expands"
              @expand-change="expandSelect"

              style="width: 100%;">
      <el-table-column label="展开" type="expand" width="80">


        <template v-slot="slot">
          <el-table :data="slot.row.childrens" size="small">
            <el-table-column prop="appKeyName" label="Key名称" align="center">

            </el-table-column>
            <el-table-column prop="appKey" label="Key" align="center">

            </el-table-column>
            <el-table-column prop="platform" :formatter="formatPlatform" label="绑定平台" align="center">

            </el-table-column>

            <el-table-column align="center" label="操作">
              <template slot-scope="scope1">

                <el-button size="mini" @click="handleKeyEdit(scope1.$index, scope1.row,scope1.row.id)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteKey(scope1.$index, scope1.row,scope1.row.id)">删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>

        </template>

      </el-table-column>

      <el-table-column label="序号" align="center" type="index" width="100">
      </el-table-column>

      <el-table-column sortable prop="applicationName" label="应用名称" show-overflow-tooltip>
      </el-table-column>
      <!--            <el-table-column sortable prop="androidPackage" label="包名称" width="200" show-overflow-tooltip>-->
      <!--            </el-table-column>-->
      <!--            <el-table-column sortable prop="androidSha1" label="SHA1值" width="400" show-overflow-tooltip>-->
      <!--            </el-table-column>-->
      <!--            <el-table-column sortable prop="appKey" label="KEY值" width="400" show-overflow-tooltip>-->
      <!--            </el-table-column>-->

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleKeyEdit(scope.$index, scope.row)">申请KEY</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑应用名称</el-button>
          <el-button size="mini" type="danger" @click="deleteApp(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>


    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="parseInt(total)" style="margin-top: 1vw">
    </el-pagination>


    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="应用名称" prop="applicationName">
          <el-input size="small" v-model="editForm.applicationName" auto-complete="off" placeholder="请输入名称"></el-input>
        </el-form-item>

        <!--        <el-form-item label="包名称" prop="name">-->
        <!--          <el-input size="small" v-model="editForm.packageName" auto-complete="off"-->
        <!--                    placeholder="请输入包名称 例如：com.powerlbs"></el-input>-->
        <!--        </el-form-item>-->

        <!--        <el-form-item label="SHA1" prop="name">-->
        <!--          <el-input size="small" v-model="editForm.sha1" auto-complete="off" placeholder="请输入SHA1"></el-input>-->
        <!--        </el-form-item>-->

        <!--        <el-form-item label="开发平台" prop="payType">-->
        <!--          <el-select size="small" v-model="editForm.appType" placeholder="请选择" class="userRole">-->
        <!--            <el-option v-for="type in appType" :label="type.key" :value="type.value" :key="type.value"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->

      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>


    <el-dialog :title="title" :visible.sync="editKeyFormVisible" width="40%" @click="closeKeyDialog('editKeyForm')">
      <el-form label-width="120px" :model="editKeyForm" :rules="rules" ref="editKeyForm">
        <el-form-item label="Key名称" prop="appKeyName">
          <el-input size="small" v-model="editKeyForm.appKeyName" auto-complete="off" placeholder="请输入Key名称"></el-input>
        </el-form-item>

        <el-form-item label="服务平台" prop="platform">
          <el-radio-group v-model="editKeyForm.platform">
            <el-radio :disabled="editKeyForm.disabled" label="1">Android平台</el-radio>
            <el-radio :disabled="editKeyForm.disabled" label="2">iOS平台</el-radio>
            <el-radio :disabled="editKeyForm.disabled" label="3">Web服务</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="PackageName" prop="androidPackage" v-if="editKeyForm.platform==1">
          <el-input size="small" v-model="editKeyForm.androidPackage" auto-complete="off"
                    placeholder="请输入包名称 例如：com.powerlbs"></el-input>
        </el-form-item>

        <el-form-item label="SHA1" prop="androidSha1" v-if="editKeyForm.platform==1">
          <el-input size="small" v-model="editKeyForm.androidSha1" auto-complete="off" placeholder="请输入SHA1"></el-input>
        </el-form-item>

        <el-form-item label="Bundle ID" prop="iosBundleId" v-if="editKeyForm.platform==2">
          <el-input size="small" v-model="editKeyForm.iosBundleId" auto-complete="off"
                    placeholder="请输入安全码Bundle ID"></el-input>
        </el-form-item>


        <el-form-item label="IP白名单" v-if="editKeyForm.platform==3">
          <el-input type="textarea" v-model="editKeyForm.ipWhiteList" :autosize="{ minRows: 5, maxRows: 8}"
                    placeholder="非必填，留空表示无IP限制
添加IP白名单后，只有白名单中的IP可访问服务
IP应该设定为服务器出口IP，支持设定IP段，
如:202.202.2.*，多个IP请每行填写一条"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeKeyDialog('editKeyForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitKeyForm('editKeyForm')">保存
        </el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import {addApp, addKey, getAppList, deleteApp, deleteKeyApi} from '../../api/appMG'

export default {
  data() {
    return {
      // 分页用到的数据
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      editKeyFormVisible: false,
      title: '添加',
      appType: [
        {key: '请选择', value: 0},
        {key: 'Android平台', value: 1},
        {key: 'iOS平台', value: 2},
        {key: 'Web平台', value: 3},
      ],
      editForm: {
        "applicationName": "",
        "packageName": "",
        "userId": this.$store.getters.getUserInfo.userId,
        "sha1": "",
        "applicationId": "",
        "appKey": "",
      },
      editKeyForm: {
        "appKeyName": "",
        "androidPackage": "",
        "androidSha1": "",
        "userId": this.$store.getters.getUserInfo.userId,
        "ipWhiteList": "",
        "id": "",
        "iosBundleId": "",
        "platform": "1",
        "applicationId": "",
        "disabled": false
      },

      // rules表单验证
      rules: {
        applicationName: [{required: true, message: '请输入应用名称', trigger: 'blur'}],
        appKeyName: [{required: true, message: '请输入Key名称', trigger: 'blur'}],
        androidPackage: [
          {required: true, message: '请输入包名称，例如：com.powerlbs', trigger: 'blur'}
        ],
        androidSha1: [{required: true, message: '请输入安全SHA1', trigger: 'blur'}],

        iosBundleId: [{required: true, message: '请输入安全码Bundle ID', trigger: 'blur'}]
      },
      formInline: {
        name: '',
      },
      listData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      currentClassId: "",
      getRowKeys(row) {
        return row.id;
      },
      expands: []
    }
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata("")
  },


  methods: {

    formatPlatform(row, column) {

      if (row.platform == 1) {
        return "Android平台"
      }

      if (row.platform == 2) {
        return "iOS平台"
      }
      if (row.platform == 3) {
        return "Web服务"
      }

    },

    handleSizeChange(newSize) {
      // pagesize改变触发
      this.pageSize = newSize
    },
    handleCurrentChange(newPage) {
      // 页码改变触发
      this.currentPage = newPage
    },

    // 获取应用列表
    getdata(applicationName) {
      this.loading = true
      getAppList(
        {
          "userId": this.$store.getters.getUserInfo.userId,
          "applicationName": applicationName
        }
      ).then(response => {
        if (response.status != 200) {
          this.$message.warning(response.message);
        } else {
          this.listData = response.data;
          this.total = this.listData.length
        }
      }).then(e => {
        console.log(e)
      })
      this.loading = false
    },

    // 搜索事件
    search() {
      this.getdata(this.formInline.name)
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      console.log(row)
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'

        this.editForm.applicationName = row.applicationName;

      } else {
        this.title = '添加'
        // this.editForm='';
        this.applicationName = "";
        this.packageName = "";
        this.userId = this.$store.getters.getUserInfo.userId;
        this.sha1 = "";
        this.id = "";
        this.appKey = "";
        this.formInline.name = "";
      }
    },

    //显示编辑界面
    handleKeyEdit: function (index, row, appKeyId) {

      this.editKeyFormVisible = true,
        console.log(index)
      console.log(row)
      console.log(appKeyId)
      if (appKeyId) {

        this.title = '编辑';
        this.editKeyForm.platform = row.platform + "";
        this.editKeyForm.androidSha1 = row.androidSha1;
        this.editKeyForm.iosBundleId = row.iosBundleId;
        this.editKeyForm.androidPackage = row.androidPackage;
        this.editKeyForm.ipWhiteList = row.ipWhiteList;
        this.editKeyForm.appKeyName = row.appKeyName;
        this.editKeyForm.disabled = true;
        this.editKeyForm.id = appKeyId;
        this.editKeyForm.applicationId = row.applicationId;

      } else {
        console.log("添加")
        this.editKeyForm.disabled = false;
        this.title = '申请KEY'
        this.editKeyForm.androidSha1 = "";
        this.editKeyForm.applicationId = row.id;
        this.editKeyForm.androidPackage = "";
        this.editKeyForm.appKeyName = "";
        this.editKeyForm.ipWhiteList = "";
        this.editKeyForm.iosBundleId = "";
        this.editKeyForm.platform = "1";
        this.editKeyForm.id = "";

      }


    },

    expandSelect(row, expandedRows) {
      if (expandedRows.length > 1) {
        this.listData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize).forEach(ele => {
          if (ele.index !== row.index) {
            this.$refs.table.toggleRowExpansion(ele, false);
          }
        })
      }
      this.expands = []
      if (expandedRows.length > 0) {
        row ? this.expands.push(row.id) : ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          addApp(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.status == 200) {

                this.getdata("")
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })

                this.editForm = {
                  "applicationName": "",
                  "packageName": "",
                  "userId": this.$store.getters.getUserInfo.userId,
                  "sha1": "",
                  "id": "",
                  "appKey": ""
                }

              } else {
                this.$message({
                  type: 'warning',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              console.log(err)
              this.$message.error('网络异常，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 编辑、增加页面保存方法
    submitKeyForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          addKey(this.editKeyForm)
            .then(res => {
              this.editKeyFormVisible = false
              this.loading = false
              if (res.status == 200) {

                this.getdata("")
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })

              } else {
                this.$message({
                  type: 'warning',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editKeyFormVisible = false
              this.loading = false
              console.log(err)
              this.$message.error('网络异常，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },

    deleteKey(index, row) {
      this.$confirm('确定要删除Key吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

          deleteKeyApi(
            {
              "id": row.id,
            }
          ).then(res => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: 'Key已删除!'
              })
              this.getdata("")
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('网络异常，请稍后再试！')
            })
        }
      ).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    deleteApp(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteApp(
            {
              "applicationName": row.applicationName,
              "userId": this.$store.getters.getUserInfo.userId
            }
          )
            .then(res => {
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '应用已删除!'
                })
                this.getdata("")
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络异常，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },

    // 关闭编辑、增加弹出框
    closeKeyDialog(formName) {
      this.editKeyFormVisible = false;
      this.$refs.editKeyForm.clearValidate();
    }
  },
  watch: {
    "editKeyForm.platform": function (newVal, oldVal) {
      this.$refs.editKeyForm.clearValidate();
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

</style>






// WEBPACK FOOTER //
// src/views/manage/AppManage.vue